<app-overlay-pop-up>
  <!-- Trigger Content -->
  <div overlay-trigger class="flex flex-col gap-[0.25rem]">
    @if (title) {
      <div class="flex flex-row items-center justify-start">
        <label [for]="inputID" class="input-title" [class.red-10]="errorProperties.errorState">
          {{title}}
        </label>
        @if (errorProperties.required) {
          <span class="red-10 line-height-80">*</span>
        }
      </div>
    }

    <div class="input-autocomplete-container">
      <input
        data-qa="input-auto-complete"
        class="input-autocomplete cursor-pointer h-[2.5rem] {{additionalClass}}"
        [class.control-shrinked-container]="isShrinked"
        [class.input-error]="errorProperties.errorState"
        [id]="inputID"
        [disabled]="isDisabled"
        [placeholder]="placeHolder"
        [(ngModel)]="selectedObject"
        (change)="emitValue(selectedObject)"
        (input)="inputChange($event.target.value)">
      <!-- user select none is used to ignore icon and to open dropdown on icon click as well-->
      <app-all-icons
        class="no-propagation user-select-none"
        [iconNameAndStyling]="'arrow-down.svg; opacity0p64; icon-size-1p125'">
      </app-all-icons>
    </div>
    @if (errorProperties.errorState) {
      <div class="input-text-error font-4">{{errorProperties.bottomText}}</div>
    }
  </div>

  <!-- Overlay Content -->
  <div overlay-content>
    <div class="overlay-dropdown flex flex-col items-center content-center">
      <div data-qa="input-auto-complete-picker-list" class="overlay-list flex flex-col items-start">
        @for (obj of filteredData | async; track obj; let i = $index) {
          <div [attr.data-qa]="dataQA + '-list-entry-' + i" class="list-block flex items-center w-full min-h-[2rem]" (click)="updateAndEmitSelectedValue(obj)">
            <span class="list-entry flex items-center w-full" [class.normal-text]="!isShrinked">{{ (isSimpleArray ? obj : obj[field]) }}</span>
          </div>
        }
      </div>
    </div>
  </div>

</app-overlay-pop-up>
